let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return null;
}
